import { styled } from 'styled-components';
import { ComposableTable } from '@abtasty/design-system';
import { CellTwoLines } from '@src/application/modules/shared/components/CellTwoLines/CellTwoLines';

export const StyledCell = styled(ComposableTable.Cell)`
  ${({ width }) => width && `min-width: ${width}%;`}

  &:not(:last-child) {
    padding-right: 16px;
  }

  .single-select-dropdown {
    width: 90%;
  }
  .tooltip {
    width: 90%;
  }
`;

export const StyledCellTwoLines = styled(CellTwoLines)`
  ${({ width }) => width && `min-width: ${width}%;`}
  padding-right: 16px;
`;
